import { render, staticRenderFns } from "./ViewDealDocumentType.vue?vue&type=template&id=73997408"
import script from "./ViewDealDocumentType.vue?vue&type=script&lang=js"
export * from "./ViewDealDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports